import { Router } from '@angular/router';
import { driver, DriveStep } from 'driver.js';

type DriverObj = ReturnType<typeof driver>;

export function getShippingDeliveryStarterSteps(
  router: Router,
  driverObj: DriverObj
): DriveStep[] {
  return [
    {
      element: '#menu-subscriptions',
      popover: {
        title: 'Shipping Delivery API',
        description: 'Shipping Delivery adalah fitur khusus untuk pengguna Enterprise, memungkinkan anda untuk membuat order, mengirim paket, dan melacak kiriamn anda. untuk sekarang mari kita lihat terlebih dahulu langkah-langkah agar anda bisa menggunakan API Shipping Delivery',
        side: 'right',
        align: 'start',
        popoverClass: 'custom-driver-popover hide-prev-btn',
        onNextClick: () => {
          (window as any).executeMenuSubscriptionsClick();
        }
      },
      onHighlighted: () => {
        (window as any).executeMenuSubscriptionsClick = () => {
          router.navigate(['/subscriptions']).then(() => {
            setTimeout(() => {
              driverObj.moveNext();
            }, 500);
          });
        };
        const el = document.querySelector('#menu-subscriptions');
        if (el) {
          (window as any).menuSubscriptionsClickListener = (e: Event) => {
            (window as any).executeMenuSubscriptionsClick();
          };
          el.addEventListener('click', (window as any).menuSubscriptionsClickListener);
        }
      },
      onDeselected: () => {
        const el = document.querySelector('#menu-subscriptions');
        if (el && (window as any).menuSubscriptionsClickListener) {
          el.removeEventListener('click', (window as any).menuSubscriptionsClickListener);
          delete (window as any).menuSubscriptionsClickListener;
        }
        delete (window as any).executeMenuSubscriptionsClick;
      }
    },
    {
      element: '#card-upgrade-subscription',
      popover: {
        title: 'Subscription',
        description: 'Untuk menjadi user Enterprise, anda bisa upgrade akun terlebih dahulu di halaman ini. Ketika tombol upgrade ditekan anda juga bisa melihat keuntungan apa saja yang akan didapatkan dan juga detail harganya.',
        side: 'right',
        align: 'start',
        popoverClass: 'custom-driver-popover hide-prev-btn'
      }
    },
    {
      popover: {
        description: '<img src="https://storage.googleapis.com/komerce/rajaongkir/api-key-ss.png" style="width: 100%; border-radius: 8px; margin-bottom: 16px; box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15) !important;" /><br>Selanjutnya ketika sudah upgrade dari Starter ke Enterprise, maka menu API Shipping Delivery dan API key baru akan terlihat.',
        popoverClass: 'custom-driver-popover custom-driver-popover-with-image disable-prev-btn',
        nextBtnText: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>',
        prevBtnText: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>',
        onPrevClick: () => {}
      }
    },
    {
      popover: {
        description: '<img src="https://storage.googleapis.com/komerce/rajaongkir/document-ss.png" style="width: 100%; border-radius: 8px; margin-bottom: 16px;box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15) !important;" /><br>Lengkapi dokumen SLA, CA, dan penuhi UAT menggunakan mode sandbox untuk testing dan memastikan integrasi berjalan dengan benar. Bila semua dokumen sudah terisi maka API Shipping Delivery siap digunakan.',
        popoverClass: 'custom-driver-popover custom-driver-popover-with-image',
        nextBtnText: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>',
        prevBtnText: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>'
      }
    },
    {
      popover: {
        description: '<img src="https://storage.googleapis.com/komerce/rajaongkir/dashboard-ss.png" style="width: 100%; border-radius: 8px; margin-bottom: 16px;box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15) !important;" /><br>Bila anda telah upgrade akun ke enterprise, klik kembali button help, dan panduan yang lebih lengkap untuk integrasi Shipping Delivery API akan tersedia. Untuk sekarang anda bisa menjelajahi service RajaOngkir lainnya secara mandiri atau dengan menekan tombol (?) di dashboard.',
        popoverClass: 'custom-driver-popover custom-driver-popover-with-image-last',
        onNextClick: () => {
          driverObj.moveNext();
        }
      },
    },
    {
      popover: {
        title: '',
        description: ''
      },
      onHighlighted: () => {
        driverObj.destroy();
      }
    }
  ];
}

